// extracted by mini-css-extract-plugin
module.exports = {"clipped-image":"clipped-image_clipped-image__O9apA","clipped-image--has-shape-outside":"clipped-image_clipped-image--has-shape-outside__3BFNw"};